var comapnyStoreMutations;
(function (comapnyStoreMutations) {
    comapnyStoreMutations["SET_BORDERS"] = "SET_BORDERS";
    comapnyStoreMutations["CHANGE_STATE"] = "CHANGE_STATE";
    comapnyStoreMutations["SET_TENANTS"] = "SET_TENANTS";
    comapnyStoreMutations["SET_AREA"] = "SET_AREA";
    comapnyStoreMutations["SET_REDIDENCES"] = "SET_REDIDENCES";
    comapnyStoreMutations["RESET_PAYLOAD"] = "RESET_PAYLOAD";
    comapnyStoreMutations["SET_PAYLOAD"] = "SET_PAYLOAD";
    comapnyStoreMutations["SET_PRE_BOOKINGS"] = "SET_PRE_BOOKINGS";
})(comapnyStoreMutations || (comapnyStoreMutations = {}));
export default comapnyStoreMutations;
